/* eslint-disable max-lines-per-function */
import React from 'react';
export const FeaturesThreeColumnsPreview = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="287" height="212" viewBox="0 0 287 212">
        <g data-name="Features: three columns" transform="translate(-817 -1075)">
            <g fill="#fff" transform="translate(817 1075)">
                <rect width="287" height="212" stroke="none" rx="4" />
                <rect width="286" height="211" x="0.5" y="0.5" fill="none" rx="3.5" />
            </g>
            <text
                fill="#718096"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(1022.5 1178)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <g data-name="Group 14411" transform="translate(1011 1099)">
                <g data-name="Group 8115">
                    <g fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1" data-name="Rectangle 6270">
                        <rect width="69" height="55" stroke="none" rx="4" />
                        <rect width="68" height="54" x="0.5" y="0.5" fill="none" rx="3.5" />
                    </g>
                </g>
                <g fill="none" stroke="#cbd5e1" strokeWidth="2" transform="translate(21.401 15)">
                    <g data-name="Rectangle 7981">
                        <rect width="26" height="26" stroke="none" rx="5" />
                        <rect width="24" height="24" x="1" y="1" rx="4" />
                    </g>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1.067 18.035l4.677-5.247 5.572 4.429"
                        data-name="Path 26926"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.629 24.805l14.983-16.28 5.847 5.479"
                        data-name="Path 26927"
                    />
                    <g strokeLinecap="round" data-name="Ellipse 1907" transform="translate(5.196 4.732)">
                        <ellipse cx="2.305" cy="2.305" stroke="none" rx="2.305" ry="2.305" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" />
                    </g>
                </g>
            </g>
            <text
                fill="#718096"
                data-name="copy2"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(937.5 1178)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <g data-name="Group 14412" transform="translate(926 1099)">
                <g data-name="Group 8115">
                    <g fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1" data-name="Rectangle 6270">
                        <rect width="69" height="55" stroke="none" rx="4" />
                        <rect width="68" height="54" x="0.5" y="0.5" fill="none" rx="3.5" />
                    </g>
                </g>
                <g
                    fill="none"
                    stroke="#cbd5e1"
                    strokeWidth="2"
                    data-name="campaign-placeholder"
                    transform="translate(21.402 15)"
                >
                    <g data-name="Rectangle 7981">
                        <rect width="26" height="26" stroke="none" rx="5" />
                        <rect width="24" height="24" x="1" y="1" rx="4" />
                    </g>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1.067 18.035l4.677-5.247 5.572 4.429"
                        data-name="Path 26926"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.629 24.805l14.983-16.28 5.847 5.479"
                        data-name="Path 26927"
                    />
                    <g strokeLinecap="round" data-name="Ellipse 1907" transform="translate(5.196 4.732)">
                        <ellipse cx="2.305" cy="2.305" stroke="none" rx="2.305" ry="2.305" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" />
                    </g>
                </g>
            </g>
            <text
                fill="#718096"
                data-name="copy2"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(852.5 1178)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <g data-name="Group 14413" transform="translate(841 1099)">
                <g data-name="Group 8115">
                    <g fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1" data-name="Rectangle 6270">
                        <rect width="69" height="55" stroke="none" rx="4" />
                        <rect width="68" height="54" x="0.5" y="0.5" fill="none" rx="3.5" />
                    </g>
                </g>
                <g
                    fill="none"
                    stroke="#cbd5e1"
                    strokeWidth="2"
                    data-name="campaign-placeholder"
                    transform="translate(21.402 15)"
                >
                    <g data-name="Rectangle 7981">
                        <rect width="26" height="26" stroke="none" rx="5" />
                        <rect width="24" height="24" x="1" y="1" rx="4" />
                    </g>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1.067 18.035l4.677-5.247 5.572 4.429"
                        data-name="Path 26926"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.629 24.805l14.983-16.28 5.847 5.479"
                        data-name="Path 26927"
                    />
                    <g strokeLinecap="round" data-name="Ellipse 1907" transform="translate(5.196 4.732)">
                        <ellipse cx="2.305" cy="2.305" stroke="none" rx="2.305" ry="2.305" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" />
                    </g>
                </g>
            </g>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                letterSpacing="-.05em"
                transform="translate(841 1190)"
            >
                <tspan x="0" y="10">
                    This is the place{' '}
                </tspan>
                <tspan x="0" y="22">
                    for your content.{' '}
                </tspan>
                <tspan x="0" y="34">
                    Did you know...
                </tspan>
            </text>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                letterSpacing="-.05em"
                transform="translate(926 1190)"
            >
                <tspan x="0" y="10">
                    This is the place{' '}
                </tspan>
                <tspan x="0" y="22">
                    for your content.{' '}
                </tspan>
                <tspan x="0" y="34">
                    Did you know...
                </tspan>
            </text>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                letterSpacing="-.05em"
                transform="translate(1011 1190)"
            >
                <tspan x="0" y="10">
                    This is the place{' '}
                </tspan>
                <tspan x="0" y="22">
                    for your content.{' '}
                </tspan>
                <tspan x="0" y="34">
                    Did you know...
                </tspan>
            </text>
            <g data-name="Button - Website Primary Button" transform="translate(851 1237)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text fill="#fff" fontFamily="Mulish-Regular, Mulish" fontSize="10" transform="translate(10 17)">
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(936 1237)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text
                    fill="#fff"
                    data-name="Button"
                    fontFamily="Mulish-Regular, Mulish"
                    fontSize="10"
                    transform="translate(10 17)"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(1021 1237)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text
                    fill="#fff"
                    data-name="Button"
                    fontFamily="Mulish-Regular, Mulish"
                    fontSize="10"
                    transform="translate(10 17)"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
);
